module.exports = __webpack_public_path__ + "static/media/Rick and Morty Chess.162f894f.jpg";